import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent, AlertDialogModel } from '../shared/alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertDialog: any;
  constructor(public dialog: MatDialog) {}

  confirm(
    header: string,
    message: string,
    yesButtonText = 'Yes',
    noButtonText = 'No',
    showNoButton = true
  ) {
    this.alertDialog = this.dialog.open(AlertDialogComponent, {
      width: '500px !important',
      maxWidth: '500px !important',
      data: new AlertDialogModel(
        header,
        message,
        yesButtonText,
        noButtonText,
        showNoButton
      ),
    });
    if (!confirm) {
      return Promise.resolve(false);
    }
    return Promise.resolve(this.alertDialog.afterClosed().toPromise());
  }
}
